// extracted by mini-css-extract-plugin
export default {"arrowBack":"ArrowBack_arrowBack__ZMu2N","arrow":"ArrowBack_arrow__ZU-av"};